{
  "iframeWaitingMessage": "Thank you for waiting. Just a few more moments...",
  "solutionIframe": "Main Content"
}
